import { FC, HTMLAttributes } from 'react';
import classNames from 'classnames';
import st from "./RadioGroup.module.scss";

interface IRadioGroupProps extends HTMLAttributes<HTMLFieldSetElement> {
	/** Размещение кнопок ( в строку или колонку ( по умолчанию в колонку ) ) */
	dir?: "row" | "col";
	/** Отступы между кнопками */
	gap?: number;
	/** Только для чтения */
	disabled?: boolean;
};

const RadioGroup: FC<IRadioGroupProps> = ( { dir = "col", gap = 8, disabled = false, children, className, style, ...otherProps } ) => {
	const classes = classNames( st.wrapper, className, st[dir] );
	return (
		<fieldset className={classes} disabled={disabled} {...otherProps} style={{ gap, ...style }}>
			{ children }
		</fieldset>
	);
};

export default RadioGroup;
